export default __webpack_public_path__ + "static/media/graphs.d207c8dd.svg";